var a={baseUrl:"https://cdn6.agoda.net/images/kite-js/logo/"};export{a as default};
